import { UAParser } from "ua-parser-js";

const getDeviceName = () => {
  const parser = new UAParser();
  const result = parser.getResult();

  let os = result.os.name || "Device";
  let browser = result.browser.name || "Browser";

  // Better user-friendly names
  if (os === "Mac OS") os = "MacBook";

  return `${os} ${browser}`; 
}


export default getDeviceName